/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Read_Only_ReassuranceInputs */

const en_zotero_read_only_reassurance = /** @type {(inputs: Zotero_Read_Only_ReassuranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read-only access — we never modify your library`)
};

const es_zotero_read_only_reassurance = /** @type {(inputs: Zotero_Read_Only_ReassuranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso de solo lectura — nunca modificamos tu biblioteca`)
};

/**
* | output |
* | --- |
* | "Read-only access — we never modify your library" |
*
* @param {Zotero_Read_Only_ReassuranceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_read_only_reassurance = /** @type {((inputs?: Zotero_Read_Only_ReassuranceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Read_Only_ReassuranceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_read_only_reassurance(inputs)
	return en_zotero_read_only_reassurance(inputs)
});